import React from "react"
import {Box} from "@mui/material"
import {packagingTokens as tk} from "@/theme/packagingTokens"

export type BadgeTone = "green" | "blue" | "amber" | "red" | "gray" | "purple"

const TONES: Record<BadgeTone, {bg: string; fg: string; dot: string}> = {
    green: {bg: tk.color.green100, fg: tk.color.greenDark, dot: tk.color.green},
    blue: {bg: tk.color.blue100, fg: tk.color.blue, dot: tk.color.blue},
    amber: {bg: tk.color.amber100, fg: tk.color.amber, dot: tk.color.amber},
    red: {bg: tk.color.red100, fg: tk.color.red, dot: tk.color.red},
    gray: {bg: "#F3F4F6", fg: tk.color.textSecondary, dot: tk.color.textTertiary},
    purple: {bg: tk.color.purple100, fg: tk.color.purple, dot: tk.color.purple},
}

type BadgeProps = {
    tone?: BadgeTone
    dot?: boolean
    icon?: React.ReactNode
    children: React.ReactNode
}

// Rémi status/type pill — light fill + dark text, optional leading status dot.
export default function Badge({tone = "gray", dot, icon, children}: BadgeProps) {
    const c = TONES[tone]
    return (
        <Box
            component={"span"}
            sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.5,
                px: 1.25,
                py: "3px",
                borderRadius: tk.radius.pill,
                fontSize: "11.5px",
                fontWeight: 600,
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                color: c.fg,
                backgroundColor: c.bg,
            }}
        >
            {dot && (
                <Box
                    component={"span"}
                    sx={{width: 6, height: 6, borderRadius: "50%", backgroundColor: c.dot}}
                />
            )}
            {icon}
            {children}
        </Box>
    )
}
